export enum ChannelTypes {
  VIBER = 'VIBER',
  PHONE = 'PHONE',
  EMAIL = 'EMAIL',
  WEB_CHAT = 'WEB_CHAT',
}
